/* eslint-disable react/no-children-prop */
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter5Adapter } from "use-query-params/adapters/react-router-5";

import { OverlaySpinnerProvider } from "components/OverlaySpinner";
import { AppAuth } from "./AppAuth";
import { MockIdMind } from "./MockIdMind";
import { GlobalErrorBoundary } from "./GlobalErrorBoundary";
import {
  AddCard,
  AddPM,
  Deposit,
  Error,
  KYC,
  KYC2,
  NotFound,
  PM,
  Payout,
  PayoutFull,
  PayoutV2,
  PaypalCallback,
  PlaidACH,
  Purchase,
  Checkout,
  PaymentSelectionFlow,
  PaymentMethodManagementFlow,
  ThreeDS2Callback,
  TOS,
  TxnDetails,
  TxnHistoryFlow,
  GDPR,
  SessionID,
} from "containers/Pages";
import MobileUploadPage from "components/CaptureOnMobileButton/MobileUploadPage";
import PrivacyPolicy from "containers/Pages/Legal/PrivacyPolicy";
import TermsOfService from "containers/Pages/Legal/TermsOfService";
import CookiesPolicy from "containers/Pages/Legal/CookiesPolicy";
import GLBANotice from "containers/Pages/Legal/GLBANotice";
import EmailVerification from "components/EmailVerification";
import { PublisherThemeConfigProvider, PublisherThemeExtendedChakraProvider } from "theme";
import { PostAuthProviders } from "./PostAuthProviders";
import { AnalyticsProvider, Analytics, LanguageProvider } from "utils";
import AllowedOriginValidationCheckHandler from "components/AllowedOriginValidationCheckHandler";
import PostedMessageLogger from "components/PostedMessageLogger";

const routeMap = [
  { path: "/3ds", component: <ThreeDS2Callback /> },
  { path: "/addcard", component: <AddCard /> },
  { path: "/addpm", component: <AddPM /> },
  { path: "/deposit", component: <Deposit /> },
  { path: "/kyc", component: <KYC /> },
  { path: "/kyc2", component: <KYC2 /> },
  { path: "/pm", component: <PM /> },
  { path: "/tos", component: <TOS /> },
  { path: "/mock-idmind", component: <MockIdMind /> },
  { path: "/paypal", component: <PaypalCallback /> },
  { path: "/plaid", component: <PlaidACH /> },
  { path: "/purchase", component: <Purchase /> },
  { path: "/checkout", component: <Checkout /> },
  { path: "/txnhistory", component: <TxnHistoryFlow /> },
  { path: "/txndetails", component: <TxnDetails /> },
  { path: "/payout", component: <Payout /> },
  { path: "/payout-full", component: <PayoutFull /> },
  { path: "/payoutv2", component: <PayoutV2 /> },
  { path: "/gdpr", component: <GDPR /> },
  { path: "/payment-selection", component: <PaymentSelectionFlow /> },
  { path: "/payment-method-management", component: <PaymentMethodManagementFlow /> },
  { path: "/mobile-upload/:roomid", component: <MobileUploadPage /> },
  { path: "/email-verification", component: <EmailVerification /> },
  { path: "/session-id", component: <SessionID /> },
  { path: "/error", component: <Error /> },
  { path: "*", component: <NotFound /> },
];

export const App = () => (
  <Router basename="/ui">
    <QueryParamProvider adapter={ReactRouter5Adapter}>
      <AnalyticsProvider analyticsInstance={Analytics()}>
        <GlobalErrorBoundary>
          <PublisherThemeConfigProvider>
            <PublisherThemeExtendedChakraProvider>
              <LanguageProvider>
                <OverlaySpinnerProvider>
                  <PostedMessageLogger />
                  <Switch>
                    <Route path="/appauth/:token" component={AppAuth} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/terms-of-service" component={TermsOfService} />
                    <Route path="/cookies-policy" component={CookiesPolicy} />
                    <Route path="/glba-notice" component={GLBANotice} />
                    <Route path="*">
                      <PostAuthProviders>
                        <AllowedOriginValidationCheckHandler />
                        <Switch>
                          {routeMap.map((r) => (
                            <Route key={r.path} path={r.path} children={r.component} {...r.props} />
                          ))}
                        </Switch>
                      </PostAuthProviders>
                    </Route>
                  </Switch>
                </OverlaySpinnerProvider>
              </LanguageProvider>
            </PublisherThemeExtendedChakraProvider>
          </PublisherThemeConfigProvider>
        </GlobalErrorBoundary>
      </AnalyticsProvider>
    </QueryParamProvider>
  </Router>
);
